/** Creating an account runs the server's beforeUserCreated function, and
 *  Firebase gives it 7 seconds. After a quiet spell the function starts cold
 *  (8–10 s seen in prod), Firebase gives up, and the creation fails with
 *  auth/internal-error — no account is made. The next attempt finds the
 *  function warm and passes in under a second (prod, 2026-10-23 11:21 → 11:22).
 *  So exactly that error is retried, a bounded number of times; anything else
 *  is a real answer and is thrown at once. */
export async function retryColdStart<T>(
	run: () => Promise<T>,
	{ attempts = 3, delayMs = 1500 }: { attempts?: number; delayMs?: number } = {},
): Promise<T> {
	for (let attempt = 1; ; attempt++) {
		try {
			return await run();
		} catch (error) {
			const code = (error as { code?: string } | null)?.code;
			if (code !== "auth/internal-error" || attempt >= attempts) throw error;
			await new Promise((resolve) => setTimeout(resolve, delayMs));
		}
	}
}
